import React, { Component } from 'react';
import { connect } from 'react-redux';

import { selectCurrentSalonCurrencySign } from 'selectors/currentSalon.selectors';
import fixed from 'utils/values/fixed.util';

import D3 from 'reports/DashboardReports/D3';

class BarChartD3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      xScale: null,
      yScale: null, // eslint-disable-line react/no-unused-state
      tipMoney: '',
      tipPercent: '',
      barWidth: this.barChartWidth(),
      colorList: ['#67b7dc', '#6794dc', '#6771dc', '#8067dc', '#a367dc', '#c767dc', '#dc67ce', '#dc67ab', '#dc6788', '#dc6967', '#dc8c67', '#dcaf67'],
    };
  }

  componentDidMount() {
    const interval = setInterval(() => {
      if (this.props.chartData) {
        clearInterval(interval);
        this.makeChart(this.props.chartData, this.state.colorList);
      }
    }, 500);
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    if ((nextProps.chartData && !this.state.xScale) || nextProps.barTitle !== this.props.barTitle) {
      this.makeChart(nextProps.chartData, this.state.colorList);
    }
  }

  // eslint-disable-next-line no-unused-vars
  onMouseOut = (e, data) => void D3.select('.bar-tooltip').style('visibility', 'hidden');

  onMouseOver = (e, dataItem) => {
    const currencyAbbr = this.props.currentSalonSign;
    // eslint-disable-next-line no-underscore-dangle
    const el = D3.select('.bar-tooltip')._groups[0][0];
    const { cssText } = el.style;
    const duration = cssText ? 600 : 0;

    let prcntChange = 0;

    const index = this.props.chartData.findIndex((item) => item.name === dataItem.name);
    if (index > 0) {
      prcntChange = Math.round(((dataItem.total - this.props.chartData[index - 1].total) / this.props.chartData[index - 1].total) * 100);
      if (Number.isNaN(prcntChange)) {
        prcntChange = 0;
      }

      let prcntStr;
      if (prcntChange !== Infinity) {
        prcntStr = prcntChange > 0 ? `+${prcntChange}%` : `${prcntChange}%`;
      }

      this.setState({ tipMoney: `${currencyAbbr}${fixed(dataItem.total)}`, tipPercent: prcntStr });
    } else {
      this.setState({ tipMoney: `${currencyAbbr}${fixed(dataItem.total)}`, tipPercent: '' });
    }

    let yPos = e.pageY;
    if (yPos > this.props.height - this.props.margin.bottom - 60) {
      yPos -= 60;
    }
    D3.select('.bar-tooltip')
      .transition()
      // width = 94, half 94 = 47
      .style('left', `${e.pageX - 47}px`)
      // .style('left', `${e.x - 47 + (188 - 512)}px`)
      .style('top', `${yPos}px`)
      .style('background-color', this.state.colorList[index])
      .duration(duration)
      .style('visibility', 'visible');
  };
  barChartWidth = () => {
    if (window.innerWidth >= 1024) {
      return 70;
    }
    if (window.innerWidth >= 768) {
      return 45;
    }
    if (window.innerWidth >= 375) {
      return 20;
    }
    if (window.innerWidth <= 320) {
      return 16;
    }
    return 70;
  };
  makeChart = (data, colorList) => {
    const currencyAbbr = this.props.currentSalonSign;
    if (this.props.margin) {
      // noinspection PointlessArithmeticExpressionJS
      const xScale = D3.scaleBand()
        .domain(data.map((datapoint) => datapoint.name))
        .rangeRound([this.props.margin.left, this.props.width - this.props.margin.right - 0])
        .padding(0.1);
      // noinspection PointlessArithmeticExpressionJS
      const yScale = D3.scaleLinear()
        .domain([0, D3.max(data, (d) => d.total)])
        .nice()
        .range([this.props.height - this.props.margin.bottom, this.props.margin.top + 0]); // 30 => 10
      let container;
      // .style('border', '1px solid #dedede');
      let containerEl;
      const interval = setInterval(() => {
        containerEl = document.querySelector('.bar-container');
        container = D3.select('.bar-container');
        if (containerEl && container) {
          clearInterval(interval);
          // eslint-disable-next-line react/no-unused-state
          this.setState({ xScale, yScale }, () => {
            container
              .append('g')
              .attr('transform', 'translate(0, 0)')
              .selectAll('.bar')
              .data(this.props.chartData)
              .join('rect')
              .classed('bar', true)
              .attr('x', (d) => xScale(d.name) - this.state.barWidth / 2 + xScale.bandwidth() / 2)
              .attr('text-anchor', 'middle')
              .attr('y', this.props.height - this.props.margin.bottom) // 10 => 0
              .attr('height', 0)
              .attr('width', this.state.barWidth) // xScale.bandwidth()) 70
              .attr('fill', (d, i) => colorList[i]) // '#933cc1')
              .attr('revenue', (d) => d.total)
              .on('mouseover', this.onMouseOver, data)
              .on('mouseout', this.onMouseOut, data)
              .transition()
              .attr('height', (d) => this.props.height - yScale(d.total) - this.props.margin.bottom)
              .attr('y', (d) => yScale(d.total))
              .duration(1000)
              .delay((d, i) => i * 300)
              .ease(D3.easeCircleOut);
            const xAxis = D3.axisBottom(xScale).tickSizeOuter(0);
            container
              .append('g')
              .attr('transform', `translate(0, ${this.props.height - this.props.margin.bottom})`)
              .call(xAxis);
            const yAxis = D3.axisLeft(yScale)
              .ticks()
              .tickFormat((m) => `${currencyAbbr}${fixed(m)}`);
            window.xAxis = xAxis;
            const xTranslate = window.innerWidth < 600 ? 65 : 75;
            container.append('g').attr('transform', `translate(${xTranslate}, 0)`).call(yAxis);
            const labelGroup = container.append('g').attr('transform', 'translate(18, 0)');
            labelGroup.append('text').attr('dy', 30).attr('x', 12).text(this.props.barTitle).classed('barTitle', true);
            labelGroup.append('text').attr('dy', 50).attr('x', 12).text(this.props.barSubTitle).classed('barSubTitle', true);
            labelGroup
              .append('text')
              .attr('dy', 80)
              .attr('x', 12)
              .text(`${currencyAbbr}${fixed(D3.sum(this.props.chartData, (d) => d.total))}`)
              .classed('barTotal', true);
          });
        }
        return null;
      }, 500);
    }
  };

  render() {
    const percentClass = this.state.tipPercent && this.state.tipPercent.indexOf('-') >= 0 ? 'minus-percent' : 'percent';
    return (
      <div>
        <div className="bar-tooltip">
          <div>{this.state.tipMoney}</div>
          <div className={percentClass}>{this.state.tipPercent}</div>
        </div>
        {this.props.allDataLoaded && !this.props.isFetching && <svg className="bar-container" width={this.props.width} height={this.props.height} />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentSalonSign: selectCurrentSalonCurrencySign(state),
});

const BarChartD3Hoc = connect(mapStateToProps)(BarChartD3);

export default BarChartD3Hoc;
